var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"2.5","cy":"2.5","r":"2.5","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"11.5","cy":"2.5","r":"2.5","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"20.5","cy":"2.5","r":"2.5","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }